import SEASON_SUMMARY from './seasonSummary.png'
import END_SEASON from './endSeason.png'
import BACKGROUND_SEASON from './background-season.png'
import END_SEASON_NEW_ONE from './end-season-new.png'

import BadgesBronze from './badge-bronze.png'
import BadgesSilver from './badge-silver.png'
import BadgesGold from './badge-gold.png'
import BadgesPlatinum from './badge-platinum.png'

import tierDiamond from './tier-diamond.png'
import tierDiamondSvg from './tier-diamond.svg'
import tierGold from './tier-gold.png'
import tierGoldSvg from './tierGoldSvg.svg'
import tierGrandMaster from './tier-grand-master.png'
import tierGrandMasterSvg from './tier-grand-master.svg'
import tierMaster from './tier-master.png'
import tierMasterSvg from './tier-master.svg'
import tierSilver from './tier-silver.png'
import tierSilverSvg from './tier-silver.svg'
import tierBronze from './tier-bronze.png'
import tierBronzeSvg from './tier-bronze.svg'
import tierDefault from './tier-default.png'
import bgModal from './bg-modal.png'
import bulletPoint from './bulletPoint.png'
import masterAvatar from './master-avatar.png'
import silverAvatar from './silver-avatar.png'
import grandMasterAvatar from './grand-master-avatar.png'
import goldAvatar from './gold-avatar.png'
import diamondAvatar from './diamond-avatar.png'
import defaultAvatar from './default-avatar.png'
import bronzeAvatar from './bronze-avatar.png'

export const IMGs = {
    SEASON_SUMMARY,
    END_SEASON,
    END_SEASON_NEW_ONE,
    BACKGROUND_SEASON,
    BadgesBronze,
    BadgesSilver,
    BadgesGold,
    BadgesPlatinum,
    tierDiamond,
    tierGold,
    tierGrandMaster,
    tierGrandMasterSvg,
    tierMaster,
    tierSilver,
    tierDefault,
    tierBronze,
    bgModal,
    tierDiamondSvg,
    tierGoldSvg,
    tierMasterSvg,
    tierBronzeSvg,
    tierSilverSvg,
    bronzeAvatar,
    masterAvatar,
    silverAvatar,
    grandMasterAvatar,
    goldAvatar,
    diamondAvatar,
    defaultAvatar,
    bulletPoint,
}
